module.exports = __webpack_public_path__ + "fca6a1b9ddbb02e135f1f01fe4dcd588.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/visa.png
// module id = 519
// module chunks = 0